import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { deviceApi } from '@/api/production/devices';
import { DeviceUpdateForm } from '@/components/forms/production/device/update-form';

export function DeviceEditPage() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const { data: device, isLoading } = useQuery({
    queryKey: ['device', id],
    queryFn: () => deviceApi.findOne(id!),
    enabled: !!id,
  });

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  if (!device) {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div>
            <h1 className="text-base font-semibold leading-7 text-gray-900">
              Nenhum equipamento encontrado
            </h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        <div>
          <h1 className="text-base font-semibold leading-7 text-gray-900">
            Atualização de equipamento
          </h1>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            Preencha o formulário abaixo para atualizar um equipamento.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        <DeviceUpdateForm device={device} />
      </div>
    </div>
  );
}
